import { useUpdateProjectMutation } from 'src/services';
import type { Project } from 'src/services/projectsService';
import { splitAutocloseWindow, joinAutocloseWindow } from 'src/utils/autocloseWindow';

// The auto-close fields every edit-integration settings form has.
export interface AutocloseFormValues {
  autocloseEnabled: boolean;
  autocloseHours: number;
  autocloseMinutes: number;
}

// The project's auto-close window as the forms' initial hours and minutes, and saving it back.
export const useProjectAutoclose = (currentProject: Project | undefined) => {
  const [updateProject, { isLoading: isLoadingUpdateProject }] = useUpdateProjectMutation();
  const { autocloseHours, autocloseMinutes } = splitAutocloseWindow(
    currentProject?.autoclose_time_window_minutes,
  );

  // Updates the project only when the form's hours and minutes change its window.
  const saveAutoclose = async (
    data: Pick<AutocloseFormValues, 'autocloseHours' | 'autocloseMinutes'>,
  ) => {
    const autocloseMinutes = joinAutocloseWindow(data.autocloseHours, data.autocloseMinutes);

    const isAutocloseChanged = currentProject?.autoclose_time_window_minutes !== autocloseMinutes;

    if (isAutocloseChanged) {
      await updateProject({
        projectId: currentProject.id,
        name: currentProject?.name,
        rate_limit_project: currentProject?.rate_limit_project,
        rate_limit_project_per: currentProject?.rate_limit_project_per,
        rate_limit_chat: currentProject?.rate_limit_chat,
        rate_limit_chat_per: currentProject?.rate_limit_chat_per,
        rate_limit_max_chats: currentProject?.rate_limit_max_chats,
        rate_limit_max_chats_per: currentProject?.rate_limit_max_chats_per,
        cocbi_project_id: currentProject?.cocbi_project_id,
        use_cocbi_model: currentProject?.use_cocbi_model,
        ai_reply_generation: currentProject?.ai_reply_generation,
        ai_text_lense: currentProject?.ai_text_lense,
        autoclose_time_window_minutes: autocloseMinutes || null,
      });
    }
  };

  return { autocloseHours, autocloseMinutes, saveAutoclose, isLoadingUpdateProject };
};
